import styled, { css } from "styled-components";

import { FontSizes, space } from "shared/styles/constants";
import { ActionDropdownTrigger } from "../ActionDropdown";
import { Spacer } from "shared/layout";

export const CalendarPickerContainer = styled.div`
  /*  set min width so width does not change when changing month */
  min-width: 200px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CalendarPickerTrigger = styled(ActionDropdownTrigger)`
  font-size: ${FontSizes.m};
`;

export const DropdownContainer = styled(Spacer)`
  padding: ${space.s};
`;

interface MonthContainerProps {
  isMobile?: boolean;
}

export const MonthContainer = styled.ul<MonthContainerProps>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${space.xs};

  ${({ isMobile }) =>
    isMobile &&
    css`
      grid-template-columns: 1fr 1fr;
    `}
`;
